module.exports = __webpack_public_path__ + "static/media/01.afe94dc0.jpg";